/* eslint-disable no-console */
import FormGroup from '@material-ui/core/FormGroup';
import { makeStyles } from '@material-ui/core/styles';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';

const themeSettings = { name: 'CataloguePageListFilterCheckbox' };
const useStyles = makeStyles(
  (theme) => ({
    root: {
      padding: '0 1.5rem',
      '& > span': {
        padding: '0',
      },
      [theme.breakpoints.down('sm')]: {
        padding: '0 0.5rem',
      },
    },
    container: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
  }),
  themeSettings,
);

const CataloguePageListFilterCheckbox: React.FC = () => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, classes.container)}>
      <FormGroup className={classes.container}>
        {/* <FormControlLabel
          control={
            <Checkbox
              checked={extraTaxonomies?.includes(`/variants/${priceGroup}/paleta`)}
              onChange={handleChange(`/variants/${priceGroup}/paleta`)}
              name='paleta'
            />
          }
          label='Palety'
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={extraTaxonomies?.includes(`/variants/${priceGroup}/karton`)}
              onChange={handleChange(`/variants/${priceGroup}/karton`)}
              name='karton'
            />
          }
          label='Karton'
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={extraTaxonomies?.includes(`/variants/${priceGroup}/displej`)}
              onChange={handleChange(`/variants/${priceGroup}/displej`)}
              name='displej'
            />
          }
          label='Displej'
        /> */}
        {/* <FormControlLabel
          control={
            <Checkbox
              checked={extraTaxonomies?.includes(`/variants/${priceGroup}/privatePrice`) ? true : false}
              onChange={handleChange(`/variants/${priceGroup}/privatePrice`)}
              name='privatePrice'
            />
          }
          label={t('cataloguePage/individualPrice')}
        /> */}
      </FormGroup>
    </div>
  );
};

export default withThemeProps(themeSettings)(CataloguePageListFilterCheckbox);
